import { JSONTransformer } from "../transformer";
import type { StorageAdapter } from "../adapter";
import type { DataTransformer } from "../transformer";

export const emptyStorageAdapter = <DT extends DataTransformer>(
  transformer: DT = JSONTransformer as DT,
): StorageAdapter<DT> => {
  return {
    type: "node",
    transformer,
    get(model, key) {
      return Promise.resolve(null);
    },
    getModels(model) {
      return Promise.resolve([]);
    },
    getString(model, key) {
      return Promise.resolve(null);
    },
    set(model, key, value) {
      return Promise.resolve(true);
    },
    setModels(model, values) {
      return Promise.resolve(true);
    },
    setString(model, key, value) {
      return Promise.resolve(true);
    },
    delete(model, key) {
      return Promise.resolve(true);
    },
    reset(model) {
      return Promise.resolve(true);
    },
  };
};
